export const environment = {
  apiBaseUrl: 'https://eldara-api-staging.onrender.com'
};
